<script>
import animatedParticlesMixin from "@/mixins/animatedParticlesMixin";

export default {
  mixins: [animatedParticlesMixin]
};
</script>
<template>
  <div class="particle-container">
    <canvas v-if="!isLowPerformance" ref="canvas"></canvas>
    <v-container
      class="d-flex align-center justify-center"
      :style="!isLowPerformance ? 'position:absolute;top:15%;left:50%;transform:translateX(-50%)' : 'height: 80vh'">
      <v-card style="width:500px;">
        <v-expand-transition>
          <router-view @close="$router.push('login')"/>
        </v-expand-transition>
      </v-card>
    </v-container>
  </div>
</template>
<style scoped>
.particle-container {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

canvas {
  width: 100%;
  height: 100%;
}
</style>
